(function () {
  const items = document.querySelectorAll('.drads-reveal');
  if (items.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    items.forEach((item) => observer.observe(item));
  } else if (items.length) {
    items.forEach((item) => item.classList.add('is-visible'));
  }

  const projectsSection = document.querySelector('.drads-projects');
  const projectsToggle = document.querySelector('.drads-projects__mobile-toggle');
  const projectsStack = document.getElementById('drads-projects-stack');

  if (!projectsSection || !projectsToggle || !projectsStack) return;

  projectsToggle.addEventListener('click', () => {
    const isExpanded = projectsSection.classList.toggle('is-expanded');
    projectsToggle.setAttribute('aria-expanded', String(isExpanded));
    projectsToggle.textContent = isExpanded
      ? projectsToggle.dataset.labelHide
      : projectsToggle.dataset.labelShow;
  });
})();
